const {
    CAMPAIGN_STRINGS: { ADD_FLASH_IN_BASKET_BANNER },
    CONTEXT: {
        ADD_FLASH_BASKET,
        ADD_FLASH_BASKET_BANNER,
        BASKET_LOVES,
        BASKET_PRODUCT,
        BASKET_REWARDS,
        BASKET_SAMPLES,
        CONTENT_STORE,
        QUICK_LOOK,
        REPLEN_PRODUCT,
        ROUGE_ENROLL_FLASH,
        ROUGE_REWARD_CARD_BANNER,
        USE_IT_WITH
    },
    Event: { ATB_FROM_BASKET_LOVE_CAROUSEL },
    LINK_TRACKING_EVENT,
    PAGE_NAMES: { BASKET }
} = require('analytics/constants');
const utils = require('analytics/utils');
const skuUtils = require('utils/Sku');

/**
 * Determine how to bind data for an event based on the context in the parameter
 * Common interactions preprocessed here include:
 * - Add to Basket
 * - Love / Un-Love
 * - Swatch Click
 * @param  {object} data An object containing specifics for this event
 */
module.exports = function (data) {
    const processEvent = require('analytics/processEvent');
    const addBindingMethods = function (methodsToAdd) {
        const existingMethods = data.bindingMethods || [];

        /* Order of binding methods matters. The base method should happen first because
         ** subsequent methods extend the originals. This is why we do existing.concat(new) */
        data.bindingMethods = existingMethods.length ? existingMethods.concat(methodsToAdd) : methodsToAdd;
    };

    switch (data.context) {
        case QUICK_LOOK: {
            addBindingMethods([require('analytics/bindings/pages/all/quickLookInteraction')]);

            break;
        }
        case BASKET_SAMPLES: {
            addBindingMethods([require('analytics/bindings/pages/basket/addSampleToBasket')]);

            break;
        }
        case BASKET_REWARDS: {
            addBindingMethods([require('analytics/bindings/pages/basket/addRewardToBasket')]);

            break;
        }
        case BASKET_LOVES: {
            addBindingMethods(function () {
                const currentEvent = utils.getMostRecentEvent(LINK_TRACKING_EVENT);
                data.eventStrings = currentEvent.eventInfo.attributes.eventStrings || [];
                data.eventStrings.push(ATB_FROM_BASKET_LOVE_CAROUSEL);

                Object.assign(currentEvent.eventInfo.attributes.eventStrings, data.eventStrings);
            });

            break;
        }
        case REPLEN_PRODUCT: {
            addBindingMethods([require('analytics/bindings/pages/basket/addReplenProduct')]);

            break;
        }
        case USE_IT_WITH: {
            addBindingMethods(function () {
                const {
                    eventInfo: { attributes }
                } = utils.getMostRecentEvent(LINK_TRACKING_EVENT);
                attributes.addToBasketLocation = `${data.context}`;
                attributes.productStrings += `|eVar72=${attributes.addToBasketLocation}`;
            });

            break;
        }
        case BASKET_PRODUCT: {
            addBindingMethods(function () {
                const {
                    eventInfo: { attributes }
                } = utils.getMostRecentEvent(LINK_TRACKING_EVENT);

                attributes.addToBasketLocation = `${data.context}`;

                if (data?.analyticsData?.displayQuantityPickerInATB) {
                    attributes.productStrings = data?.analyticsData?.productStrings[0] + `|eVar72=${attributes.addToBasketLocation}`;
                } else {
                    attributes.productStrings += `|eVar72=${attributes.addToBasketLocation}`;
                }
            });

            break;
        }
        case ROUGE_ENROLL_FLASH: {
            addBindingMethods([require('analytics/bindings/pages/product/addFlashAndProductToBasket')]);

            break;
        }
        case ADD_FLASH_BASKET_BANNER: {
            addBindingMethods(function () {
                const currentEvent = utils.getMostRecentEvent(LINK_TRACKING_EVENT);
                currentEvent.eventInfo.attributes.actionInfo = ADD_FLASH_IN_BASKET_BANNER;
                currentEvent.eventInfo.attributes.internalCampaign = ADD_FLASH_IN_BASKET_BANNER;
                currentEvent.eventInfo.attributes.productStrings += '|eVar72=' + BASKET;
            });

            break;
        }
        case ROUGE_REWARD_CARD_BANNER: {
            addBindingMethods([require('analytics/bindings/pages/basket/addRRCFromBannerToBasket')]);

            break;
        }
        case CONTENT_STORE: {
            addBindingMethods(function () {
                const currentEvent = utils.getMostRecentEvent(LINK_TRACKING_EVENT);
                currentEvent.eventInfo.attributes.biRewardType = data.sku.biType;
            });

            break;
        }
        case ADD_FLASH_BASKET: {
            addBindingMethods([require('analytics/bindings/pages/all/addFlashToBasket')]);

            break;
        }
        default: {
            //Do nothing
        }
    }

    /* Use originalContext for cases when we shouldn't grab the data from current context but another one
     ** For example when a 2nd level Modal does not trigger an s.t call
     ** we should grab the data from the 1st level modal (if it had an s.t call) */
    const currentEventData = utils.getLastAsyncPageLoadData({ pageType: data.originalContext || data.context });
    const anaObj = {
        ...data,
        ...currentEventData
    };

    if (data.originalContext === 'preCheckoutModal' && data.analyticsData.pageName) {
        anaObj.pageName = data.analyticsData.pageName;
    }

    processEvent.process(LINK_TRACKING_EVENT, { data: anaObj });

    if (data.sku && skuUtils.isFlash(data.sku)) {
        Sephora.analytics.promises.tagManagementSystemReady.then(() => {
            const addToCartPixels = require('analytics/addToCartPixels');
            const { skuId, listPrice } = data.sku;
            const googleAnalyticsChangedBasketData = {
                id: skuId,
                name: 'Sephora FLASH Subscription',
                brand: 'Sephora',
                variant: '',
                quantity: 1,
                price: listPrice
            };

            addToCartPixels.googleAnalyticsAddToBasketEvent(googleAnalyticsChangedBasketData);
        });
    }
};
